﻿import { PropsWithChildren } from 'react';
import { useAuth } from '../AuthContext';
import AuthLoadingScreen from './AuthLoadingScreen';
import LoginPage from './LoginPage';

export default function AuthGuard({ children }: PropsWithChildren) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <AuthLoadingScreen />;
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return <>{children}</>;
}
